import * as Assets from "Data/Assets";
import { MusicGameSpotlight } from "GameObjects/MusicGame/Spotlight";
import * as HLF from "html-living-framework";
import "pixi-picture";
export class MusicGameOverlaySpotlight extends MusicGameSpotlight {
    protected startSolo(pData: { character: number; loop: number; bar: number; time: number; }): void {
        this.sprite.visible = true;
    }
    protected stopSolo(pData: { character: number; }): void {
        this.sprite.visible = false;
    }
    protected onSoloQueued(pData: { character: number; loop: number; }): void {
        this.sprite.visible = true;
    }
    protected makeSprite() {
        const newSprite = new PIXI.picture.Sprite(
            HLF.PixiUtils.getTexture(Assets.MUS_LIGHT_ + this._data.name, Assets.SPRITESHEET_SPOTLIGHTS)
        );
        newSprite.scale.set(2);
        newSprite.blendMode = PIXI.BLEND_MODES.OVERLAY;
        return newSprite;
    };
}